export default "__VITE_ASSET__vaq9E$u8__"